import React from "react";
import PropTypes from "prop-types";
import styles from "./ToggleSwitch.module.scss";
import clsx from "clsx";
import Label from "../Label/Label";

const ToggleSwitch = (
  {
    toggled,
    label,
    onChange,
    disabled,
    reverseLayout,
    labelClass,
    toggledClass,
    toggledLabelClass,
    color,
    offColor,
    colorLabel,
    required,
    size,
  },
  ref
) => {
  const rootClasses = clsx("d-flex", toggledClass);

  const toggledActiveClassChecker = (type) =>
    (!disabled && toggled && color === type) || (offColor === type && !toggled && !disabled);

  const switchClasses = clsx(styles.toggleSwitch, "mt-1", {
    [styles.defaultColor]: !toggled && offColor === "neutral",
    "bg-primary": toggledActiveClassChecker("primary"),
    "bg-error": toggledActiveClassChecker("error"),
    [styles.toggleSwitchDisabled]: disabled,
    [styles.large]: size === "lg",
    [styles.medium]: size === "md",
    [styles.small]: size === "sm",
    [styles.extrasmall]: size === "xs",
  });

  const switchButtonClasses = clsx(styles.toggleSwitchButton, {
    [styles.toggled]: toggled,
  });

  const inputToggleClasses = clsx("d-none", {
    [styles.toggleSwitchDisabled]: disabled,
  });

  const labelClasses = clsx(
    styles.label,
    toggled && toggledLabelClass ? toggledLabelClass : labelClass,
    {
      "mr-2": reverseLayout,
      "ml-2": !reverseLayout,
    }
  );

  return (
    <div className={rootClasses} data-testid="ToggleSwitch">
      <div
        className={switchClasses}
        onClick={() => !disabled && onChange && onChange(!toggled)}
        data-testid="ToggleSwitchInput"
      >
        <input
          className={inputToggleClasses}
          type="checkbox"
          checked={toggled}
          disabled={disabled}
          onChange={() => onChange(!toggled)}
          data-testid="ToggleSwitchInputReal"
          ref={ref}
        />
        <span className={switchButtonClasses} />
      </div>
      <Label
        className={labelClasses}
        color={colorLabel}
        disabled={disabled}
        required={required}
        onClick={() => !disabled && onChange && onChange(!toggled)}
        dataTestId="ToggleSwitchLabel"
      >
        {label}
      </Label>
    </div>
  );
};

const ToggleSwitchWithRef = React.forwardRef(ToggleSwitch);

ToggleSwitchWithRef.defaultProps = {
  color: "primary",
  offColor: "neutral",
  colorLabel: "default",
  size: "xs",
  disabled: false,
  error: false,
  onChange: () => {},
  reverseLayout: false,
  required: false,
};

const oneOfColor = ["neutral", "primary", "danger", "error"];

ToggleSwitchWithRef.propTypes = {
  offColor: PropTypes.oneOf(oneOfColor),
  colorLabel: PropTypes.string,
  color: PropTypes.oneOf(oneOfColor),
  size: PropTypes.oneOf(["lg", "md", "sm", "xs"]),
  toggled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  labelClass: PropTypes.string,
  reverseLayout: PropTypes.bool,
  required: PropTypes.bool,
};

export default ToggleSwitchWithRef;
